<template lang="pug">
  .layout-view(:class="classes")
    template(v-if="!isMobile")
      .layout-view__controls
        v-btn(
          medium
          :disabled="!allowAdd"
          @click="openCreate")
          v-icon(
            position-left
            font-size="1"
            icon="plus").mr-1
          | {{ 'base.add_ration' | translate }}
    template(v-else)
      v-btn(
        :disabled="isConsultant"
        fab
        @click="openCreate")
        v-icon(
          font-size="1.2"
          icon="plus")

    rations-table(
      v-if="!isMobile"
      ref="table"
      @edit="openEdit")
    rations-table-mobile(v-else)

    v-dialog(
      max-width="1230"
      :value="modals.showDetail"
      @input="closeModal")
      detail-modal(
        :selected="selected"
        @update="onUpdate"
        @close="closeModal")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import DetailModal from './modals/DetailModal'

const RationsTable = () => import('./table/RationsTable')
const RationsTableMobile = () => import('./table/RationsTableMobile')

export default {
  name: 'FarmRations',

  mixins: [adaptationMixin],

  components: {
    DetailModal,
    RationsTable,
    RationsTableMobile
  },

  data: () => ({
    modals: {
      showDetail: false
    },
    selected: null
  }),

  computed: {
    allowAdd () {
      return this.hasPermission('ration', 'add')
    },

    showModal () {
      return this.selected !== null ||
        this.modals.showDetail
    },

    classes () {
      return {
        'offset-top': false
      }
    }
  },

  methods: {
    openEdit (item) {
      this.selected = item
      this.modals.showDetail = true
    },

    openCreate () {
      this.selected = null
      this.modals.showDetail = true
    },

    onUpdate () {
      if (this.$refs.table) {
        this.$refs.table.loadData()
      }
    },

    closeModal () {
      this.modals.showDetail = false
      this.selected = null
    }
  }
}
</script>
